import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { trackSharedLinkOpened } from '../lib/share';

/**
 * Landing for shared links (Share to WhatsApp, Oct 2026):
 *   /:clubSlug/e/:eventId → the hub with that fixture/session open
 *   /:clubSlug/n/:annId   → the hub on News with that post highlighted
 *
 * The short paths exist so the backend can recognise them for link previews
 * (lib/shareMeta.js) and so the native apps can claim them; the hub's own
 * ?event= / ?news= deep-link handling does the rest (the same ?event= the
 * push notifications use). Signed-in opens are counted (shared_link_opened).
 */
export default function SharedLinkRedirect({ kind }) {
  const { clubSlug, id } = useParams();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) trackSharedLinkOpened(clubSlug, { kind, targetId: id });
  }, [loading, user, clubSlug, kind, id]);

  // Wait for auth so the open is attributed before we leave this page.
  if (loading) return null;
  const param = kind === 'news' ? 'news' : 'event';
  return <Navigate to={`/${clubSlug}?${param}=${encodeURIComponent(id)}`} replace />;
}
